(function () {
  function getSelectedColor() {
    var radio = document.querySelector(
      '.product-form__input input[type="radio"][name^="Väri"]:checked'
    );

    if (radio) return radio.value;

    var select = document.querySelector('select[name^="Väri"]');
    if (select) return select.value;

    return null;
  }

  function getProductHandle() {
    var element = document.querySelector('[data-product-handle]');
    return element ? element.dataset.productHandle : null;
  }

  function resetSlider() {
    var slider = document.querySelector('.slider.product__media-list');

    if (slider) {
      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  function normalizeColorName(color) {
    return (color || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getColorCandidates(color) {
    var key = normalizeColorName(color);

    var colorGroups = [
      ['huulipunapuna', 'huulipunainen', 'lipstick red'],
      ['ballet pink', 'balletpink', 'vaaleanroosa'],
      ['apricot', 'aprikoosi'],
      ['azure', 'azuurinsininen'],
      ['black', 'musta'],
      ['blue', 'sininen'],
      ['brown', 'ruskea'],
      ['caramel', 'karamelli'],
      ['champagne', 'samppanja'],
      ['cinnamon', 'kaneli'],
      ['coffee', 'kahvi'],
      ['cognac', 'konjakki'],
      ['colourless', 'väritön'],
      ['coral', 'koralli'],
      ['dark blue', 'tummansininen'],
      ['dark brown', 'tummanruskea'],
      ['dark taupe', 'tumma taupe'],
      ['denim', 'deniminsininen', 'denimsininen'],
      ['forest green', 'metsänvihreä'],
      ['fuchsia', 'fuksia'],
      ['gold', 'kulta'],
      ['green', 'vihreä'],
      ['grey', 'gray', 'harmaa'],
      ['honey', 'hunaja'],
      ['light blue', 'vaaleansininen'],
      ['light taupe', 'vaalea taupe'],
      ['light grey', 'light gray', 'vaaleanharmaa'],
      ['lilac', 'liila'],
      ['lime green', 'limenvihreä'],
      ['lined', 'viivoitettu'],
      ['mint green', 'mintunvihreä'],
      ['natural', 'luonnonväri', 'luonnonvaalea'],
      ['olive green', 'oliivinvihreä'],
      ['orange', 'oranssi'],
      ['pastel yellow', 'pastellinkeltainen'],
      ['purple', 'purppura'],
      ['red', 'punainen'],
      ['teal', 'petrooli', 'turkoosi / teal'],
      ['turquoise', 'turkoosi'],
      ['white', 'valkoinen'],
      ['yellow', 'keltainen'],

      /* Uudet Tuscany Leather -värit */
      ['chocolate brown', 'chocolate', 'suklaanruskea'],
      ['natural', 'natural leather', 'luonnonvaalea'],
      ['teal', 'turkoosi / teal', 'turkoosi/teal'],
      ['burgundy', 'wine red', 'viininpunainen', 'bordeaux']
    ];

    for (var i = 0; i < colorGroups.length; i += 1) {
      if (colorGroups[i].indexOf(key) !== -1) {
        return colorGroups[i];
      }
    }

    return [key];
  }

  function mediaMatchesColor(mediaAlt, handle, colorCandidates) {
    var normalizedAlt = normalizeColorName(mediaAlt);
    var normalizedHandle = normalizeColorName(handle);

    return colorCandidates.some(function (candidate) {
      var prefix =
        normalizedHandle + ' - ' + normalizeColorName(candidate);

      return normalizedAlt.startsWith(prefix);
    });
  }

  function filterGallery() {
    var color = getSelectedColor();
    var handle = getProductHandle();

    if (!color || !handle) return;

    var colorCandidates = getColorCandidates(color);
    var items = document.querySelectorAll(
      '[class*="product__media-item"]'
    );

    if (!items.length) return;

    var matchingItems = [];

    items.forEach(function (item) {
      var mediaAlt =
        item.dataset.auneliqMediaAlt ||
        (item.querySelector('img')
          ? item.querySelector('img').getAttribute('alt')
          : '') ||
        '';

      if (mediaMatchesColor(mediaAlt, handle, colorCandidates)) {
        matchingItems.push(item);
      }
    });

    /*
     * Jos väriä vastaavia kuvia ei löydy, galleria jätetään ennalleen.
     * Näin puutteelliset kuvatiedot eivät tee galleriaa tyhjäksi.
     */
    if (!matchingItems.length) return;

    items.forEach(function (item) {
      item.style.display =
        matchingItems.indexOf(item) !== -1 ? '' : 'none';
    });

    resetSlider();
  }

  document.addEventListener('DOMContentLoaded', function () {
    filterGallery();

    document.addEventListener('change', function (event) {
      if (
        event.target.name &&
        event.target.name.startsWith('Väri')
      ) {
        filterGallery();
      }
    });

    document.addEventListener('variant:changed', filterGallery);
  });

  if (document.readyState !== 'loading') {
    filterGallery();
  }
})();
